/* Signage.inc redesign - case studies (ported from the redesign's main.js). Two places use it:
   - the case studies page (sections/sg-case-studies.liquid, #cs-grid): filters by sign type and business,
     "Show more" (12 at a time), deep link #c-<id>;
   - the "Get Featured In Our Case Studies" slider (sections/sg-reviews.liquid, #lp-cs): the demo's 12 featured
     case studies (a category page leads with its own sign types). "Get a quote like this" opens the quote form
     inside the dialog; on the quote page it preselects the sign type in the main form instead (sg-lp.js lpPick).
   Both share the case study dialog (snippets/sg-case-modal.liquid: prev/next, "more like this", short quote form).
   Data: window.SG_CASES (assets/sg-case-studies.js). Photos: complete URLs (a bare file name falls back to Shopify Files).
   The quote form sends through assets/sg-lead.js like every other redesigned form. */
(function () {
  'use strict';
  var doc = document;
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  var SG = window.SG || {}, DATA = window.SG_CASES;
  var grid = $('#cs-grid') || $('#lp-cs'), lpMode = !!grid && grid.id === 'lp-cs';
  if (!grid || !DATA || grid.dataset.ready) return;
  grid.dataset.ready = '1';

  var BASE = SG.assetBase || '';
  function imgUrl(img) { return /^(https?:)?\/\//.test(img) ? img : BASE + img; }
  var QUOTE = (SG.urls && SG.urls.quote) || '/pages/get-a-quote';
  function esc(t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function stars(n) { return new Array(n + 1).join('&#9733;'); }
  function el(tag, cls, text) { var n = doc.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function quoteUrl(tid) { return QUOTE + (tid ? (QUOTE.indexOf('?') > -1 ? '&' : '?') + 'type=' + encodeURIComponent(tid) : ''); }
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  var csData = DATA.cases, csIdx = {};
  csData.forEach(function (d, i) { csIdx[d.id] = i; });

  /* ---- render ---- */
  if (lpMode) {
    /* slider: same markup as build.py cs_card in stories_section ("Customer" instead of "Verified buyer",
       the quote link is a button) */
    function excerpt(c, n) {
      n = n || 210;
      var t = c.text;
      if (!t) return 'Verified buyer review: ' + c.stars + ' out of 5 stars.';
      if (t.length <= n) return t;
      return t.slice(0, n).replace(/\s+\S*$/, '').replace(/[,.;:\- ]+$/, '') + '…';
    }
    /* which picks: the category's own (category page, ?cat=<id> or data-cat) or the general 12 */
    var F = DATA.featured || {}, cat = grid.getAttribute('data-cat') || '';
    if (!cat && window.URLSearchParams) cat = (new URLSearchParams(location.search).get('cat') || '').toLowerCase();
    if (cat && !(F.cats || {})[cat]) {
      ((window.SG_SIGN_DATA || {}).categories || []).forEach(function (c) { if ((c.aliases || []).indexOf(cat) > -1) cat = c.id; });
    }
    var picks = ((F.cats || {})[cat] || F.all || []).filter(function (id) { return csIdx[id] != null; });
    var limit = +(grid.getAttribute('data-limit') || 12);
    grid.innerHTML = picks.slice(0, limit).map(function (id) {
      var i = csIdx[id], c = csData[i];
      var media = c.img
        ? '<div class="csc-ph"><img src="' + esc(imgUrl(c.img)) + '" width="' + c.w + '" height="' + c.h + '" alt="' + esc(c.alt) + '" loading="lazy" decoding="async"></div>'
        : '<div class="csc-ph ph"><span class="ph-q" aria-hidden="true">&ldquo;</span><span class="ph-l">' + esc(c.label) + '</span></div>';
      return '<article class="csc" id="c-' + esc(c.id) + '" data-i="' + i + '" data-g="' + esc(c.g) + '" data-b="' + esc(c.b) + '">' + media + '<div class="csc-b">' +
        '<span class="csc-type">' + esc(c.label) + '</span>' +
        '<h3 class="csc-title"><button class="csc-open" type="button" aria-label="' + esc('Open case study: ' + c.title) + '">' + esc(c.title) + '</button></h3>' +
        '<p class="csc-q">' + esc(excerpt(c)) + '</p>' +
        '<div class="csc-f"><div class="csc-who"><span class="csc-stars" role="img" aria-label="' + c.stars + ' out of 5 stars">' + stars(c.stars) + '</span><small>' + esc(c.name) + ' &middot; Customer</small></div>' +
        '<button class="csc-cta" type="button" data-pick="' + esc(c.type_id || '') + '">Get a quote like this ' + ARROW + '</button></div></div></article>';
    }).join('');
    /* the slider arrows (assets/sg-main.js) measure the track on resize */
    try { window.dispatchEvent(new Event('resize')); } catch (e) { }
  } else {
    /* case studies page: same markup as build.py cs_tile / case_studies_page */
    var mini = $('[data-cs-mini]');
    if (mini) mini.innerHTML = '<li><b>' + DATA.stats.reviews + '</b> verified reviews</li><li><b>' + DATA.stats.five + '</b> five-star</li><li><b>' + DATA.stats.photos + '</b> customer photos</li>';
    var fbtn = function (attr, f, on) {
      return '<button type="button" class="cs-fb" ' + attr + '="' + esc(f.id) + '" aria-pressed="' + (on ? 'true' : 'false') + '"><span>' + esc(f.label) + '</span><small>' + f.n + '</small></button>';
    };
    $('#cs-f-type').innerHTML = DATA.typeFilters.map(function (f, i) { return fbtn('data-ft', f, i === 0); }).join('');
    $('#cs-f-biz').innerHTML = DATA.bizFilters.map(function (f, i) { return fbtn('data-fb', f, i === 0); }).join('');
    grid.innerHTML = csData.map(function (c, i) {
      var media = c.img
        ? '<img src="' + esc(imgUrl(c.img)) + '" width="' + c.w + '" height="' + c.h + '" alt="' + esc(c.alt) + '" loading="lazy" decoding="async">'
        : '<span class="ph-q" aria-hidden="true">&ldquo;</span>';
      return '<article class="csc csc-tile' + (c.img ? '' : ' ph') + '" id="c-' + esc(c.id) + '" data-i="' + i + '" data-g="' + esc(c.g) + '" data-b="' + esc(c.b) + '">' +
        '<div class="csc-ph">' + media + '</div><div class="csc-ov"><span class="csc-type">' + esc(c.label) + '</span>' +
        '<h3 class="csc-title"><button class="csc-open" type="button" aria-label="' + esc('Open case study: ' + c.title) + '">' + esc(c.title) + '</button></h3>' +
        '<span class="csc-stars" role="img" aria-label="' + c.stars + ' out of 5 stars">' + stars(c.stars) + '</span></div></article>';
    }).join('');
  }

  /* ---- filters + show more (case studies page only) ---- */
  var csCards = $$('.csc', grid), csGroup = 'all', csBiz = 'all', csShown = 12, CS_STEP = 12;
  var csMore = $('#cs-more'), csCount = $('#cs-count'), csFBtns = lpMode ? [] : $$('.cs-fb'), csFound = $('#cs-found'), csReset = $('#cs-reset');
  function csList() {
    if (lpMode) return csCards;
    return csCards.filter(function (c) { return (csGroup === 'all' || c.getAttribute('data-g') === csGroup) && (csBiz === 'all' || c.getAttribute('data-b') === csBiz); });
  }
  function csRender() {
    if (lpMode) return; // slider: every card stays visible
    var list = csList();
    csCards.forEach(function (c) { c.hidden = true; });
    list.forEach(function (c, i) { c.hidden = i >= csShown; });
    var n = Math.min(csShown, list.length);
    csCount.textContent = 'Showing ' + n + ' of ' + list.length + ' case studies';
    csMore.hidden = n >= list.length;
    csFound.textContent = list.length + (list.length === 1 ? ' project' : ' projects');
    csReset.hidden = csGroup === 'all' && csBiz === 'all';
  }
  function csSync() {
    csFBtns.forEach(function (x) {
      var on = x.hasAttribute('data-ft') ? x.getAttribute('data-ft') === csGroup : x.getAttribute('data-fb') === csBiz;
      x.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function csSetGroup(g) { csGroup = g; csShown = CS_STEP; csSync(); csRender(); }
  if (!lpMode) {
    csFBtns.forEach(function (x) {
      x.addEventListener('click', function () {
        if (x.hasAttribute('data-ft')) csGroup = x.getAttribute('data-ft'); else csBiz = x.getAttribute('data-fb');
        csShown = CS_STEP; csSync(); csRender();
      });
    });
    csReset.addEventListener('click', function () { csBiz = 'all'; csSetGroup('all'); });
    csMore.addEventListener('click', function () { csShown += CS_STEP; csRender(); });
  }

  /* ---- dialog ---- */
  var csDlg = $('#csm');
  if (!csDlg) return;
  var csCard = $('.csm-card', csDlg), csImg = $('.csm-media img', csDlg), csMedia = $('.csm-media', csDlg);
  var csCur = -1, csLast = null;
  function csFill(idx) {
    var d = csData[idx]; csCur = idx;
    csCard.classList.remove('quoting', 'thanks');
    csCard.classList.toggle('no-media', !d.img);
    if (d.img) {
      csImg.src = imgUrl(d.img); csImg.alt = d.alt;
      csMedia.style.setProperty('--bg', 'url("' + imgUrl(d.img) + '")');
    }
    var tags = $('#csm-tags'); tags.textContent = '';
    d.tags.forEach(function (t) { tags.appendChild(el('span', '', t)); });
    $('#csm-t').textContent = d.title;
    var sub = $('#csm-sub'); sub.textContent = '';
    sub.appendChild(el('span', 'stars-row', new Array(d.stars + 1).join('★')));
    sub.appendChild(doc.createTextNode(d.stars + '/5 · Verified buyer review · ' + d.date));
    $('#csm-about').textContent = d.about;
    var facts = $('#csm-facts'); facts.textContent = '';
    [['Customer', d.name], ['Business', d.business], ['Industry', d.industry], ['Sign type', d.label], ['Reviewed', d.date]].forEach(function (f) {
      if (!f[1]) return;
      var wrap = el('div'); wrap.appendChild(el('dt', '', f[0])); wrap.appendChild(el('dd', '', f[1])); facts.appendChild(wrap);
    });
    $('#csm-qsec').hidden = !d.text;
    $('#csm-q').textContent = d.text ? '“' + d.text + '”' : '';
    var hl = $('#csm-hl'); hl.textContent = '';
    d.hl.forEach(function (h) { hl.appendChild(el('span', '', h)); });
    $('#csm-hsec').hidden = !d.hl.length;
    var cta = $('#csm-cta');
    cta.setAttribute('href', quoteUrl(d.type_id));
    cta.firstChild.nodeValue = d.type_id ? 'Get a quote for ' + d.label + ' ' : 'Get a free quote & mockup ';
    if (!lpMode) $('#csm-all').textContent = 'See all ' + (d.g === 'other' ? 'other sign' : d.label) + ' case studies';
    var rel = $('#csm-rel'); rel.textContent = '';
    var shown = 0;
    d.rel.forEach(function (id) {
      var r = csData[csIdx[id]]; if (!r || !r.img) return;
      var b = el('button'); b.type = 'button';
      var im = doc.createElement('img'); im.src = imgUrl(r.img); im.alt = r.alt; im.loading = 'lazy';
      b.appendChild(im); b.appendChild(el('span', '', r.business || r.title));
      b.addEventListener('click', function () { csFill(csIdx[id]); });
      rel.appendChild(b); shown++;
    });
    $('#csm-rsec').hidden = !shown;
    var list = csList().map(function (c) { return +c.getAttribute('data-i'); }), pos = list.indexOf(idx);
    $('#csm-count').textContent = (pos < 0 ? 1 : pos + 1) + ' of ' + (list.length || csData.length);
    $('.csm-scroll', csDlg).scrollTop = 0;
    if (!lpMode && history.replaceState) history.replaceState(null, '', '#c-' + d.id);
  }
  function csOpen(idx) { csLast = doc.activeElement; csFill(idx); csDlg.hidden = false; doc.body.style.overflow = 'hidden'; $('.csm-x', csDlg).focus(); }
  function csClose() {
    csDlg.hidden = true; doc.body.style.overflow = ''; csCard.classList.remove('quoting', 'thanks');
    if (!lpMode && history.replaceState) history.replaceState(null, '', location.pathname + location.search);
    if (csLast && csLast.focus) csLast.focus();
  }
  function csStep(dir) {
    var list = csList().map(function (c) { return +c.getAttribute('data-i'); });
    if (!list.length) return;
    var p = list.indexOf(csCur); if (p < 0) p = 0;
    csFill(list[(p + dir + list.length) % list.length]);
  }
  csCards.forEach(function (c) { $('.csc-open', c).addEventListener('click', function () { csOpen(+c.getAttribute('data-i')); }); });
  $('.csm-x', csDlg).addEventListener('click', csClose);
  $('.csm-bd', csDlg).addEventListener('click', csClose);
  $('.csm-pv', csDlg).addEventListener('click', function () { csStep(-1); });
  $('.csm-nx', csDlg).addEventListener('click', function () { csStep(1); });
  if (lpMode) $('#csm-all').hidden = true; // slider: no jump to the filters, they are on the case studies page
  else {
    $('#csm-all').addEventListener('click', function () {
      var d = csData[csCur];
      csSetGroup(d.g); csClose();
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---- quote form inside the dialog: ends on a thank-you screen, nobody is sent anywhere ---- */
  var qForm = $('#csm-form'), qErr = $('.csm-qerr', qForm), qFile = $('#cq-file'), qFn = $('.fname', qForm);
  function fieldWrap(x) { return x.closest('.fld'); }
  function validate(form) {
    var ok = true, first = null;
    $$('[required]', form).forEach(function (x) {
      var v = (x.value || '').trim(), bad = !v;
      if (!bad && x.type === 'email') bad = !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
      if (!bad && x.type === 'tel') bad = v.replace(/\D/g, '').length < 10;
      var w = fieldWrap(x); if (w) w.classList.toggle('bad', bad);
      if (bad) { ok = false; first = first || x; }
    });
    if (first) first.focus();
    return ok;
  }
  function csQuoteOpen() {
    var d = csData[csCur];
    $('#csm-qt').textContent = d.type_id ? 'Get a quote for ' + d.label : 'Get your free quote & mockup';
    qForm.reset(); qFn.textContent = ''; qErr.textContent = '';
    $$('.fld', qForm).forEach(function (w) { w.classList.remove('bad'); });
    csCard.classList.remove('thanks'); csCard.classList.add('quoting');
    $('.csm-scroll', csDlg).scrollTop = 0;
    setTimeout(function () { $('#cq-name').focus({ preventScroll: true }); }, 60);
  }
  function csQuoteClose() { csCard.classList.remove('quoting', 'thanks'); $('.csm-scroll', csDlg).scrollTop = 0; }
  $('#csm-cta').addEventListener('click', function (e) { e.preventDefault(); csQuoteOpen(); });
  $('#csm-qback').addEventListener('click', csQuoteClose);
  $('#csm-tclose').addEventListener('click', csClose);
  /* slider "Get a quote like this": the dialog straight on its quote form (the quote page's main form
     handles [data-pick] itself: sg-lp.js lpPick) */
  if (lpMode && !$('#qfForm')) {
    $$('.csc-cta[data-pick]', grid).forEach(function (b) {
      b.addEventListener('click', function () { csOpen(+b.closest('.csc').getAttribute('data-i')); csQuoteOpen(); });
    });
  }
  qFile.addEventListener('change', function () {
    var f = qFile.files[0];
    if (f && f.size > 20 * 1024 * 1024) { qFile.value = ''; qFn.textContent = 'That file is over 20 MB. Please choose a smaller one.'; return; }
    qFn.textContent = f ? f.name : '';
  });
  $$('input,textarea', qForm).forEach(function (x) { x.addEventListener('input', function () { var w = fieldWrap(x); if (w) w.classList.remove('bad'); qErr.textContent = ''; }); });
  qForm.addEventListener('submit', function (e) {
    e.preventDefault(); qErr.textContent = '';
    if (!validate(qForm)) return;
    var d = csData[csCur], f = qForm.elements;
    var btn = $('button[type=submit]', qForm), lbl = $('span', btn).textContent;
    btn.disabled = true; $('span', btn).textContent = 'Sending...';
    var nm = f.name.value.trim(), em = f.email.value.trim();
    window.SGLead.submit({
      name: nm, email: em, phone_number: f.phone.value.trim(),
      details: (f.details.value.trim() ? f.details.value.trim() + '\n\n' : '') + 'Case study: ' + d.title,
      sign_types: d.label
    }, { files: qFile.files && qFile.files[0] ? [qFile.files[0]] : [], recordSource: 'Case Studies' }).then(function () {
      $('#csm-tn').textContent = nm.split(/\s+/)[0] || 'friend';
      $('#csm-ts').textContent = d.label; $('#csm-te').textContent = em || 'your inbox';
      csCard.classList.add('thanks'); $('.csm-scroll', csDlg).scrollTop = 0;
    }).catch(function () {
      qErr.textContent = 'Sorry, that did not send. Please try again, or call ' + (SG.phone || '') + ' or email ' + (SG.email || '') + '.';
    }).then(function () { btn.disabled = false; $('span', btn).textContent = lbl; });
  });

  doc.addEventListener('keydown', function (e) {
    if (csDlg.hidden) return;
    if (e.key === 'Escape') csClose();
    if (e.key === 'ArrowLeft') csStep(-1);
    if (e.key === 'ArrowRight') csStep(1);
  });
  csRender();
  if (!lpMode) {
    var csHash = location.hash.match(/^#c-(.+)$/);
    if (csHash) {
      var at = csIdx[decodeURIComponent(csHash[1])];
      if (at != null) { csShown = Math.max(csShown, at + 1); csRender(); csOpen(at); }
    }
  }
  if (window.SGReveal) window.SGReveal(doc);
})();
